import React from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

import PlaybookCategoryIcon from "./PlaybookCategoryIcon";

import "./playbook-category-card.css";

class PlaybookCategoryCard extends React.PureComponent {
	render() {
		const { category, countText, isEmpty, onClick } = this.props;

		return (
			<button type="button" className={clsx("playbook-category-card", isEmpty && "playbook-category-card--empty")} onClick={onClick}>
				<span className="playbook-category-card__head">
					<PlaybookCategoryIcon icon={category.icon} />
					<span className="playbook-category-card__name">{category.name}</span>
				</span>
				{category.description && <span className="playbook-category-card__description">{category.description}</span>}
				<span className={clsx("playbook-category-card__count", isEmpty && "playbook-category-card__count--empty")}>
					{countText}
					{!isEmpty && <Icon.ArrowRight size={13} />}
				</span>
			</button>
		);
	}
}

export default PlaybookCategoryCard;
